import Vue from 'vue';
export default Vue.extend({
    name: 'apiKeysItem',
    data: () => ({
        isCopyBtnClick: false
    }),
    props: {
        id: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        apiKey: {
            type: String,
            required: true
        },
        itBuddyKey: {
            type: Boolean,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        copied: {
            type: Boolean,
            required: true
        },
        deleting: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        handleKeyClick(event) {
            const vm = this;
            const { copyBtn: copyBtnRef } = vm.$refs;
            let isCopyBtnClick = false;
            for (const pathEl of event.path) {
                if (pathEl === copyBtnRef.$el)
                    isCopyBtnClick = true;
            }
            if (!isCopyBtnClick)
                vm.$emit('onKeyClick', vm.id);
        }
    }
});
